import { useCallback, useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export function useDisparosRiskAck(userId: string | undefined, workspaceId: string | null) {
  const [checking, setChecking] = useState(true);
  const [acknowledged, setAcknowledged] = useState(false);

  const checkAcknowledgment = useCallback(async () => {
    if (!userId || !workspaceId) {
      setAcknowledged(false);
      setChecking(false);
      return;
    }

    setChecking(true);

    try {
      const { data, error } = await supabase
        .from("workspace_members")
        .select("disparos_risk_accepted_at")
        .eq("workspace_id", workspaceId)
        .eq("user_id", userId)
        .maybeSingle();

      if (error) {
        console.error("[useDisparosRiskAck] Error checking acknowledgment:", error);
        setAcknowledged(false);
        return;
      }

      setAcknowledged(!!data?.disparos_risk_accepted_at);
    } catch (err) {
      console.error("[useDisparosRiskAck] Unexpected error:", err);
      setAcknowledged(false);
    } finally {
      setChecking(false);
    }
  }, [userId, workspaceId]);

  useEffect(() => {
    checkAcknowledgment();
  }, [checkAcknowledgment]);

  const markAcknowledged = useCallback(() => {
    setAcknowledged(true);
  }, []);

  return { acknowledged, checking, markAcknowledged, recheck: checkAcknowledgment };
}
